import { createAction } from 'typesafe-actions';

export const setPage = createAction('INACTIVE_USERS_PAGE_SET', (action) => (pageIndex: number) => action(pageIndex));
export const setPageSize = createAction(
  'INACTIVE_USERS_PAGE_SIZE_SET',
  (action) => (pageSize: number) => action(pageSize)
);
